import React from "react";
import styled from "styled-components";

import { getConfig } from "../../../../../../utils/config";

const config = getConfig();

const colors = config.theme.colors;

const LogoutButton = styled.button`
  width: 100%;
  padding: 12px 20px;
  border: none;
  background: transparent;
  color: #f5f5f5;
  font-size: 14px;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    
  }

  i {
    font-size: 16px;
  }

  span {
    font-weight: 500;
    letter-spacing: 0.5px;
  }
`;

export default LogoutButton;


// WEBPACK FOOTER //
// ./src/views/AppViews/Sidebar/components/Nav/LogoutButton/index.jsx